import { CatalystInsightCategory, CatalystSubcategories } from '@api';
import { Icon, IconProps } from '@design/components/icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './CatalystInsightTooltip.module.scss';

export interface CatalystInsightTooltipProps {
  category: CatalystInsightCategory;
  subCategory?: CatalystSubcategories;
  iconProps: IconProps;
}

export const CatalystInsightTooltip = ({
  category,
  subCategory,
  iconProps,
}: CatalystInsightTooltipProps) => {
  const { t } = useTranslation(['insights']);

  return (
    <div className={styles.tooltipWrapper}>
      <Icon {...iconProps} size={32} />
      <div className={styles.rightWrapper}>
        <div className={styles.titleLabel}>
          {category === 'company'
            ? t('insights:catalyst.titleCompanyCatalyst')
            : t('insights:catalyst.titleMarketCatalyst')}
        </div>
        <div className={styles.categoryLabel}>
          {subCategory
            ? /* i18next-extract-mark-context-next-line ["financial_operational_updates", "corporate_actions_strategic_announcements", "management_leadership_changes", "legal_regulatory_events"] */
              t(`catalyst.subcategories.${subCategory}`)
            : null}
        </div>
      </div>
    </div>
  );
};
